<template>
  <div>
    <error-box v-if="error" @reload="load()" />

    <loader v-else-if="loading" />

    <template v-if="!error && !loading">
      <v-teleport to="header">
        <div class="flex mb-20">
          <el-button-group>
            <el-button
              :type="onlyArchived ? 'default' : 'primary'"
              size="medium"
              round
              @click="onlyArchived = false">
              {{ $tc('general.active') }}
            </el-button>
            <el-button
              :type="onlyArchived ? 'primary' : 'default'"
              icon="el-icon-takeaway-box"
              size="medium"
              round
              @click="onlyArchived = true">
              {{ $tc('general.archive') }}
            </el-button>
          </el-button-group>
        </div>
      </v-teleport>

      <panel :title="$tc('seminar.seminars_and_camps')">
        <template v-slot:actions>
          <RouterLink :to="{ name: 'CreateSeminar' }">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="medium"
              round>
              {{ $tc('seminar.create_seminar') }}
            </el-button>
          </RouterLink>
        </template>

        <seminars-table :data="filteredSeminars" @refresh="load" />
      </panel>
    </template>
  </div>
</template>

<script>
import SeminarsTable from '@/components/seminars/SeminarsTable'

export default {
  components: {
    SeminarsTable
  },

  data () {
    return {
      onlyArchived: false,
      error: false,
      loading: false
    }
  },

  computed: {
    seminars () {
      return this.$store.state.seminars.data || []
    },

    filteredSeminars () {
      return this.seminars.filter(seminar => {
        return this.onlyArchived ? seminar.isArchived : !seminar.isArchived
      })
    }
  },

  created () {
    this.$store.commit('app/set', {
      title: this.$tc('seminar.seminars_and_camps'),
      breadcrumbs: [
        { text: this.$tc('seminar.seminars_and_camps') }
      ]
    })
    this.load()
  },

  methods: {
    async load () {
      this.loading = true
      try {
        await this.$store.dispatch('seminars/load')
        this.error = false
      } catch (e) {
        console.error(e)
        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
